import React, { useState } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import ChowaSidebar from './ChowaSidebar';
import ChowaHeader from './ChowaHeader';
import classNames from 'classnames';

// 共通のスタイル設定（DashboardLayoutと同じ）
export const commonStyles = {
  // レイアウト
  layout: {
    container: "flex-1 min-h-0 overflow-auto",
    content: "space-y-4 p-4 md:p-8", // 余白を詰める
    section: "space-y-4"             // 余白を詰める
  },
  // グリッド
  grid: {
    default: "grid grid-cols-1 gap-6",
    responsive: {
      sm: "grid-cols-1",
      md: "md:grid-cols-2",
      lg: "lg:grid-cols-3"
    }
  },
  // カード
  card: {
    base: "bg-white dark:bg-gray-800 rounded-lg shadow-lg border border-gray-200 dark:border-gray-700",
    padding: {
      default: "p-4",
      large: "p-6"
    }
  },
  // テキスト
  text: {
    title: "text-xl font-semibold text-gray-900 dark:text-white",
    subtitle: "text-lg font-medium text-gray-800 dark:text-gray-100",
    body: "text-sm lg:text-base text-gray-600 dark:text-gray-300"
  },
  // フォーム
  form: {
    input: "w-full px-3 py-2 bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500",
    label: "block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1",
    button: "px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white font-medium rounded-md transition-colors"
  }
};

const ChowaDashboardLayout = ({ routes, sidebarConfig }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  return (
    <div className="layout-container min-h-screen flex flex-col">
      {/* サイドバーオーバーレイ */}
      {isSidebarOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-20 lg:hidden"
          onClick={toggleSidebar}
        />
      )}
      <div className="flex flex-1 min-h-0">
        {/* サイドバー */}
        <aside
          className={classNames(
            "fixed z-30 inset-y-0 left-0 w-64 transition-transform transform lg:relative lg:translate-x-0",
            isSidebarOpen ? "translate-x-0" : "-translate-x-full"
          )}
        >
          <div className="h-full" data-sidebar-element>
            <ChowaSidebar sidebarConfig={sidebarConfig} />
          </div>
        </aside>
        {/* メインエリア */}
        <div className="flex-1 flex flex-col min-w-0 bg-gray-200 dark:bg-gray-900 overflow-hidden">
          <ChowaHeader toggleSidebar={toggleSidebar} />
          <main className={classNames(commonStyles.layout.container)}>
            {/* ここに各ダッシュボードの中身が入る */}
            <Routes>
              {/* ルートパスへのアクセス時に/mainへリダイレクト */}
              <Route 
                path="/" 
                element={<Navigate to="main" replace />} 
              />
              
              {/* 通常のルート */}
              {routes.map((route) => (
                <Route
                  key={route.path}
                  path={route.path}
                  element={<route.component />}
                />
              ))}

              {/* 未定義のパスへのアクセス時も/mainへリダイレクト */}
              <Route 
                path="*" 
                element={<Navigate to="main" replace />} 
              />
            </Routes>
          </main>
        </div>
      </div>
    </div>
  );
};

export default ChowaDashboardLayout; 